var _rect, _rect2, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultIntegrationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 173,
    height: 165,
    viewBox: "0 0 173 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 173,
    height: 165,
    rx: 12,
    fill: "url(#paint0_linear_760_9721)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 172.5,
    height: 164.5,
    rx: 11.75,
    stroke: "#E6E6E6",
    strokeOpacity: 0.901961,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M74.4583 41C74.4583 44.3855 74.4583 49.6692 74.4583 49.6692C64.8633 53.2883 57.2883 60.8633 53.6271 70.4583H48C46.3431 70.4583 45 71.8015 45 73.4583V92.7083C45 94.3652 46.3431 95.7083 48 95.7083H53.6692C57.2883 105.303 64.8633 112.92 74.4583 116.54V122.167C74.4583 123.824 75.8015 125.167 77.4583 125.167H96.7083C98.3652 125.167 99.7083 123.824 99.7083 122.167V116.498C109.303 112.878 116.92 105.303 120.54 95.7083H126.167C127.824 95.7083 129.167 94.3652 129.167 92.7083V73.4583C129.167 71.8015 127.824 70.4583 126.167 70.4583H120.498C116.878 60.8633 109.303 53.2883 99.7083 49.6271V41M82.875 49.4167H91.2917V57.8333H82.875M74.4583 58.8854V63.25C74.4583 64.9069 75.8015 66.25 77.4583 66.25H96.7083C98.3652 66.25 99.7083 64.9069 99.7083 63.25V58.8854C104.674 61.4525 108.714 65.4925 111.281 70.4583H106.917C105.26 70.4583 103.917 71.8015 103.917 73.4583V92.7083C103.917 94.3652 105.26 95.7083 106.917 95.7083H111.281C108.714 100.674 104.674 104.714 99.7083 107.281V102.917C99.7083 101.26 98.3652 99.9167 96.7083 99.9167H77.4583C75.8015 99.9167 74.4583 101.26 74.4583 102.917V107.281C69.4925 104.714 65.4525 100.674 62.8854 95.7083H67.25C68.9069 95.7083 70.25 94.3652 70.25 92.7083V73.4583C70.25 71.8015 68.9069 70.4583 67.25 70.4583H62.8854C65.4525 65.4925 69.4925 61.4525 74.4583 58.8854ZM53.4167 78.875H61.8333V87.2917H53.4167M112.333 78.875H120.75V87.2917H112.333M82.875 108.333H91.2917V116.75H82.875",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_760_9721",
    x1: 6.39449,
    y1: 82.4999,
    x2: 173.349,
    y2: 82.4999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultIntegrationIcon);
export default __webpack_public_path__ + "static/media/DefaultIntegrationIcon.cea5666e143714fd35a200c5320a832f.svg";
export { ForwardRef as ReactComponent };